export const environment = {
  production: false,
  version: '20261103.1',
  buildNumber: '20261103.1',
  passportUrl: 'https://test-passport.nibo.com.br',
  clientId: '55a6447d-712e-4614-8fcc-6f6bc487f3f7',
  clientSecret: '492B0A3441A64EC9B558AF139BBA1F2F8AD8FEC208CF441FBD',
  salesAPI: 'https://hubspot.nibo.com.br/api',
  salesAPIToken: 'Y27JtsrXHIDg-tnS4xsPCPMFaa7ZdXGZ1VCQ724mP_GRAzFuLBg7Rg==',
  azureBlobAccountName: 'brniboemailsignature',
  azureBlobSasToken: 'spr=https&sv=2026-04-06&si=upload-foto&sr=c&sig=oVjkYr5KD3Vuk90couQVCqmtG5XfMmDd1kK43mkdKq4%3D',
  NiboWhatsappAPI: 'https://test-api-whatsapp-web.nibo.com.br/api/whatsapp',
  NiboWhatsappAPIToken: 'pMuonTgAxHhnhZ2uDLi_M4bw0LbalAUX9tEJx6AdjzQOAzFuu1c2BA==',
  NiboWhatsappNewAPI: 'https://test-api-whatsapp-web.nibo.com.br/api',
  NiboWhatsappSignalR: 'https://test-api-whatsapp-web.nibo.com.br/api',
  NiboWhatsappSignalR2: 'https://test-whatsapp-api.nibo.com.br',
  filesAPIUrl: 'https://test-files.nibo.com.br',
  cdnUrl: 'https://cdn.nibo.com.br/packages/whatsapp-test/latest',
  datadog: {
    env: 'test-server',
    forwardErrorsToLogs: true,
    key: 'pubbb5960de1872d257b12e624a8e83a44f',
  },
};
